import React, { Component, useState } from "react";
import "./Archive.css";
import InterestingJSON from "../../../../assets/json/InterestingEvents.json";
import Comments from "./../../../../components/Comments/Comments";
import PostedComments from "../../../../components/PostedComments/PostedComments";
import LabelTagButton from "../../../../components/LabelTagButton/LabelTagButton";
import { FFmpeg } from '@ffmpeg/ffmpeg';
import { fetchFile } from '@ffmpeg/util';
import BeeVideoContainer from "../../../../components/BeeVideo/BeeVideoContainer/BeeVideoContainer";


const ffmpeg = new FFmpeg();


export default class BeeStreamArchive extends Component {

    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.SharableVideoLink = this.SharableVideoLink.bind(this);
        let videoUrl;
        let audioUrl;
        let apiUrl;
        if (process.env.REACT_APP_CORS_MODE === "dev") {
            // Dev server url for video files (API URL inferred from the current page).
            console.log("Running in dev mode.");
            videoUrl = "https://appmais-dev.cs.appstate.edu/videos/";
            audioUrl = "https://appmais-dev.cs.appstate.edu/audio/";
            apiUrl = "";
        }
        else if (process.env.REACT_APP_CORS_MODE === "local") {
            // Local development url for video files and the API.
            console.log("Running in local dev mode.");
            apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";
            videoUrl = `${apiUrl}/videos/`;
            audioUrl = `${apiUrl}/audio/`;
        }
        else {
            console.log("Running in prod mode.");
            videoUrl = "https://appmais.cs.appstate.edu/videos/";
            audioUrl = "https://appmais-dev.cs.appstate.edu/audio/";
            apiUrl = "";
        }
        this.state = {
            hiveSelect: "",
            dateSelect: "",
            timeSelect: "",
            hivelst: [],
            selection: [],
            videoLoaded: true,
            videoExists: true,
            videoFetchAttempted: false,
            videoUrl: "",
            audioUrl: "",
            staticAudioUrl: audioUrl,
            staticVideoUrl: videoUrl,
            apiUrl: apiUrl,
            h264Url: "",
            error: null,
            daylst: [],
            timelst: [],
            submittedSelection: [],
            secondDropDis: false,
            thirdDropDis: false,
            isLoading: false,
            dropDownCss:
                "px-1 text-sm bg-gray-100 border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 " +
                "focus:ring focus:ring-indigo-200 focus:ring-opacity-50 mt-4",
            beeThemedButton:
                "bg-yellow-400 text-black font-semibold px-4 py-2 rounded-lg hover:bg-yellow-500 " +
                "focus:outline-none focus:ring-2 focus:ring-yellow-300 focus:ring-opacity-50 mt-7",
        };
    }

    async onSubmit(e) {
        e.preventDefault();
        // Update submitted selection state
        this.setState(
            {
                isLoading: true,
                submittedSelection: [
                    this.state.hiveSelect,
                    this.state.dateSelect,
                    this.state.timeSelect,
                ],
            },
            async () => {
                try {
                    const { FilePath } = await BeeVideoContainer.fetchVideoFilePath(
                        this.state.apiUrl,
                        this.state.hiveSelect,
                        this.convertDate(this.state.dateSelect),
                        this.convertTimeTo24HourFormat(this.state.timeSelect)
                    );
                    const stitchedVideo = await BeeVideoContainer.setVideoUrlAndStitchWithAudio(
                        this.state.staticVideoUrl,
                        this.state.staticAudioUrl,
                        FilePath
                    );
                    this.setState({
                        videoUrl: stitchedVideo,
                        videoLoaded: true,
                        videoExists: true,
                        videoFetchAttempted: true,
                        isLoading: false,
                    });
                } catch (error) {
                    console.error("Error processing video:", error);
                    // Reseting loading state
                    this.setState({isLoading: false});
                }
            }
        );
    }

    componentDidMount() {
        fetch(`${this.state.apiUrl}/api/hives`)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error("Failed to fetch hives");
                }
            })
            .then((data) => {
                this.setState({ hivelst: data });
            })
            .catch((error) => {
                this.setState({ error: error.toString() });
            });

        const queryParams = new URLSearchParams(window.location.search);
        const hiveS = queryParams.get("hiveSelect");
        const dateS = queryParams.get("dateSelect");
        const timeS = queryParams.get("timeSelect");

        if (hiveS && dateS && timeS) {
            this.setState(
                {
                    hiveSelect: hiveS,
                    dateSelect: dateS,
                    timeSelect: timeS,
                    secondDropDis: true,
                    thirdDropDis: true,
                },
                () => {
                    this.setState({
                        submittedSelection: [
                            this.state.hiveSelect,
                            this.state.dateSelect,
                            this.state.timeSelect,
                        ],
                    });
                    this.fetchVideoFilePath(hiveS, dateS, timeS).then(async (data) => {
                        await this.setVideoUrlAndStitchWithAudio(data.FilePath);
                    });
                },
            );
        }
    }

    fetchDays(hive) {
        fetch(`${this.state.apiUrl}/api/videofiles/${hive}/days/`)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error("Failed to fetch hives");
                }
            })
            .then((data) => {
                this.setState({ daylst: data });
            })
            .catch((error) => {
                this.setState({ error: error.toString() });
            });
    }

    fetchTimes(selectedDay, hive) {
        fetch(
            `${this.state.apiUrl}/api/videofiles/${hive}/times/${this.convertDate(selectedDay)}`,
        )
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error("Failed to fetch hives");
                }
            })
            .then((data) => {
                this.setState({ timelst: data });
            })
            .catch((error) => {
                this.setState({ error: error.toString() });
            });
    }


    /**
     * Fetches the video file path from the API.
     *
     * @param {string} selectedHive - The selected hive. Example: AppMAIS10L
     * @param {string} selectedDay - The selected day. Format is YYYY-MM-DD. Example: 2023-04-22.
     * @param {string} selectedTime - The selected time. Format is HH-MM-SS. Example: 14-00-00.
     * @returns {Promise<Object>} A promise that resolves to the API response containing the file path.
     */
    async fetchVideoFilePath(selectedHive, selectedDay, selectedTime) {
        const response = await fetch(
            `${this.state.apiUrl}/api/videofiles/${selectedHive}/${this.convertDate(selectedDay)}/${this.convertTimeTo24HourFormat(selectedTime)}/filepath`
        );
        if (response.ok) {
            return response.json();
        } else {
            throw new Error("Failed to fetch the video filepath");
        }
    }




    //Sets VideoExists and videoLoaded to false if video does not load in HTML
    videoErrorHandler = () => {
        this.setState({ videoExists: false, videoLoaded: false });
    };



    /* Changes date strings like 02/18/2003 to 02-18-2003 for query */
    convertDate = (dateStr) => {
        const [month, day, year] = dateStr.split("/");
        return `${year}-${month}-${day}`;
    };

    handleHiveChange = (e) => {
        const hive = e.target.value;
        this.setState({
            hiveSelect: hive,
            dateSelect: "",   // Reset the date selection
            timeSelect: "",   // Reset the time selection
            secondDropDis: !!hive,
            thirdDropDis: false,
        }, () => {
            this.fetchDays(hive);
        });
    };


    handleDateChange = (e) => {
        const date = e.target.value;
        this.setState({
            dateSelect: date,
            timeSelect: "",   // Reset the time selection
            thirdDropDis: !!date,  // Enable the time dropdown only if a date is selected
        }, () => {
            this.fetchTimes(date, this.state.hiveSelect);
        });
    };

    handleTimeChange = (e) => {
        this.setState({ timeSelect: e.target.value });
    };

    /*
        Converts a readable time String (2:35:00 pm) to 24-Hour clock format (14:35:00)
     */
    convertTimeTo24HourFormat = (timeString) => {
        // Extract hours, minutes, seconds, and am/pm parts from the string
        const [time, amOrPm] = timeString.split(" ");
        const [hoursString, minutesString, secondsString] = time.split(":");
        let hours = parseInt(hoursString, 10);

        // Convert 12-hour hours back to 24-hour format
        if (amOrPm === "pm" && hours !== 12) {
            hours += 12;
        }
        if (amOrPm === "am" && hours === 12) {
            hours = 0;
        }

        return `${String(hours).padStart(2, "0")}:${minutesString}:${secondsString}`;
    };

    /*
        Returns a UTCDate in the format of 2023-10-18T15:55:00.000Z
     */
    convertDateTime = (dateStr, timeStr) => {
        const convertedTime = this.convertTimeTo24HourFormat(timeStr);

        // Split the converted time to separately adjust hours
        let [hours, minutes, seconds] = convertedTime.split(":");
        hours = parseInt(hours, 10) + 4; // Add 4 hours for timezone adjustment

        // Handle overflow of hours into the next day
        if (hours >= 24) {
            hours -= 24;
        }

        // Reconstruct the time string with adjusted hours
        const adjustedTime = `${hours.toString().padStart(2, "0")}:${minutes}:${seconds}`;
        return `${dateStr}T${adjustedTime}.000Z`;
    };

    SharableVideoLink(e) {
        e.preventDefault();
        const queryParams = new URLSearchParams();
        queryParams.append("hiveSelect", this.state.hiveSelect);
        queryParams.append("dateSelect", this.state.dateSelect);
        queryParams.append("timeSelect", this.state.timeSelect);
        const SharableLink = `${window.location.origin}${window.location.pathname}?${queryParams}`;
        console.log(SharableLink);
        navigator.clipboard.writeText(SharableLink).then(() => {
            alert("Link Copied to Clipboard!");
        });
    }



    render() {
        //This is an example of an implicit return in jsx, no need for curly braces after the arrow or a return
        const hiveOptions = Object.values(this.state.hivelst).map((tag) => (
            //{console.log(tag)}
            <option key={tag}>  {tag}  </option>
        ));
        const dateOptions = Object.values(this.state.daylst.reverse()).map((tag) => (
            <option key={tag}> {tag} </option>
        ));
        const timeOptions = this.state.timelst
            .slice()
            .map((item, index) => (
                <option key={index} value={item.timestamp}>
                    {item.timestamp}
                </option>
            ));
        const tagButtons = this.state.videoUrl && Object.values(InterestingJSON.TagList).map((tag) => (
            <LabelTagButton
                label={tag}
                filePath={this.state.h264Url}
                UTCDate={this.convertDateTime(this.convertDate(this.state.dateSelect), this.state.timeSelect)}
                hiveName={this.state.hiveSelect}
                apiUrl={this.state.apiUrl}
                key={`${tag.replace(/ /g, '')}TagButton`} // Keyed by tag with spaces removed (globally by the /g)
            />
        ));

        const videoTitle =
            this.state.videoUrl &&
            this.state.videoLoaded &&
            this.state.videoExists &&
            this.state.submittedSelection.length
                ? `Video from ${this.state.submittedSelection[0]} on ${this.state.submittedSelection[1]} at ${this.state.submittedSelection[2]}`
                : null;


        return (
            <div className="flex-container">
                <div className="sect main-content">
                    <div className="min-h-[85vh]">
                        <h1 className="font-bold text-4xl text-center pb-3">Archive</h1>
                        <form>
                            <div className="dropdown-div">
                                <select
                                    name="HiveSelect"
                                    onChange={this.handleHiveChange}
                                    className={`dropdown ${this.state.dropDownCss}`}
                                    value={this.state.hiveSelect}  // controlled component
                                >
                                    <option value="">Choose a Hive</option>
                                    {hiveOptions}
                                </select>

                                <select
                                    name="dateSelect"
                                    onChange={this.handleDateChange}
                                    className={`dropdown ${this.state.dropDownCss}`}
                                    disabled={!this.state.secondDropDis}
                                    value={this.state.dateSelect}  // controlled component
                                >
                                    <option value="">Choose a Date</option>
                                    {dateOptions}
                                </select>

                                <select
                                    name="timeSelect"
                                    onChange={this.handleTimeChange}
                                    className={`dropdown ${this.state.dropDownCss}`}
                                    disabled={!this.state.thirdDropDis}
                                    value={this.state.timeSelect}  // controlled component
                                >
                                    <option value="">Choose a Time</option>
                                    {timeOptions}
                                </select>

                            </div>

                            <button className={this.state.beeThemedButton} onClick={this.onSubmit}>Submit</button>
                        </form>

                        <div className="video-div">
                            {this.state.isLoading ? (
                                <div className="loading-screen">
                                    <h2>Loading...</h2>
                                </div>
                            ) : (
                                <>
                                    {videoTitle ? (
                                        <>
                                            <h2 className="font-bold text-2xl text-center mt-3 mb-3 pb-3">{videoTitle}</h2>
                                            <video className="video-div" id="video"
                                                   src={this.state.videoUrl} controls
                                                   autoPlay onError={this.videoErrorHandler}>
                                                Your browser doesn't support HTML5 video.
                                            </video>

                                            <button className="UrlButton" onClick={this.SharableVideoLink}> Link🔗</button>

                                            <div className="button-tags-container">
                                                {tagButtons}
                                            </div>
                                            <Comments
                                                hive={this.state.hiveSelect}
                                                filePath={this.state.h264Url}
                                                utcDate={this.convertDate(this.state.dateSelect)}
                                                utcTime={this.convertTimeTo24HourFormat(this.state.timeSelect)}
                                            />
                                            <PostedComments
                                                hive = {this.state.hiveSelect}
                                                UTCDate={this.convertDateTime(this.convertDate(this.state.dateSelect), this.state.timeSelect)}
                                            />
                                        </>
                                    ) : this.state.videoFetchAttempted && !this.state.videoExists ? (
                                        <h2 className="font-bold text-2xl text-center mt-3 mb-3 pb-3">
                                            Uh oh! No Video found from {this.state.submittedSelection[0]} on {this.state.submittedSelection[1]} at {this.state.submittedSelection[2]}
                                        </h2>
                                    ) : null}
                                </>
                            )}
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}